import React , {useEffect , useState} from 'react'
import { EnglishIcon, KSA, menueIcon } from '../../assets/svgIcons'
import "./style.css"
import { useNavigate } from 'react-router-dom'
import greenLogo from "../../assets/images/logo.png"
import HeaderIcons from '../header/headerIcons'
import SearchBox from '../header/searchBox'
import UseGeneral from '../../hooks/useGeneral'
import IconWithText from '../iconWithText'

const MobileHeader = ({open , setOpen}) => {
  const navigate = useNavigate("/");
  const { language, changeLanguage, data } = UseGeneral();


  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`mobile_header_container ${isSticky ? "sticky-header" : ""}`}>
      <div className='mobile_top_header'>
          <div className='menueIcon' onClick={()=>setOpen(true)}>{menueIcon}</div>
        <div className={`mobile_search ${language}`}>
          <SearchBox />
        </div> 
      </div>
      <div className='mobile_bottom_header'>
      {/* <HeaderIcons /> */}
      {language?.toLowerCase() == "ar" ? (
        <IconWithText
          icon={EnglishIcon}
          reverse={true}
          pointer={true}
          text={"EN"}
          onClick={() => changeLanguage("en")}
        />
      ) : (
        <IconWithText
          icon={KSA}
          reverse={true}
          pointer={true}
          text={"العربية"}
          onClick={() => changeLanguage("ar")}
        />
      )}
      <div style={{cursor:'pointer'}} className="mobile_logo" onClick={() => navigate("/")}>
        <img src={greenLogo} alt="" />
      </div>


      </div>
    </div>
  )
}

export default MobileHeader
